import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 顧客情報一覧
export async function getTossUpCustomerInfos(id: string) {
  try {
    const path = "tossUpCustomerInfos";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [], option_data: [] };
    }
    const option_data: {
      [key: string]: string | number;
    }[] = response.data.option_data;
    return { sudDatas: response.data.fetch_data, option_data };
  } catch (error) {
    return { sudDatas: [], option_data: [] };
    // logout();
  }
}
